<template>
  <div class="c-table" ref="table">
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe row-class-name="h-row" @selection-change="select">
      <el-table-column type="selection" width="30"></el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :fixed="col.fixed"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <div>
              <el-button
                type="text"
                size="small"
                @click="$emit('on-quick-debug', scope.row)"
                v-if="isNeedTestConnectMedia(scope.row.mediaId, scope.row.callType)"
                >快速联调
              </el-button>
              <el-button type="text" size="small" @click="$emit('on-plan-edit', scope.row)" v-if="hasOperateTrackPlan">编辑</el-button>
              <el-button type="text" size="small" @click="$emit('on-data-entry', scope.row)" v-if="hasDataEntryPlan">录入</el-button>
            </div>

            <div>
              <el-button type="text" size="small" @click="$emit('on-plan-copy', scope.row)" v-if="hasOperateTrackPlan">复制</el-button>
              <el-button type="text" size="small" @click="$emit('on-account-edit', scope.row)" v-if="hasModifyPlanAccount">
                账号修改
              </el-button>
            </div>
            <div>
              <el-button type="text" size="small" @click="$emit('on-proxy-control', scope.row)" v-if="hasAgentPlan"> 代投扣量 </el-button>
            </div>
          </div>
          <div v-else-if="col.key === 'planName'">
            <Col span="20">
              <el-button type="text" @click="$emit('on-show', scope.row)">
                {{ scope.row[col.key] }}
              </el-button>
            </Col>
            <Col v-if="scope.row[col.key]" span="4">
              <Icon
                size="14"
                type="md-copy"
                color="#409EFF"
                class="g-pull-right m-edit click-style"
                v-clipboard:success="onCopy"
                v-clipboard:copy="scope.row[col.key]"
              />
            </Col>
          </div>
          <div v-else-if="col.key === 'mediaPlanId'">
            <span>{{ scope.row[col.key] | convertMediaPlanId }}</span>
            <Icon
              @click="$emit('on-media-plan-id', scope.row)"
              type="md-create"
              class="g-pull-right m-edit click-style"
              size="14"
              color="#409EFF"
            />
          </div>
          <div v-else-if="col.key.indexOf('Addr') > -1 || col.key === 'field4' || col.key === 'mediaPackExtendId'">
            <Row>
              <Col span="20">
                <span
                  v-if="scope.row[col.key] && scope.row[col.key].indexOf('639') > 0 && scope.row.field3 && scope.row.field3 == 2"
                  style="color: red; font-weight: bold"
                  >包体停更
                </span>
                <span v-else>{{ scope.row[col.key] || '————' }}</span>
              </Col>
              <Col v-if="scope.row[col.key]" span="4">
                <Icon
                  size="14"
                  type="md-copy"
                  color="#409EFF"
                  class="g-pull-right m-edit click-style"
                  v-clipboard:success="onCopy"
                  v-clipboard:copy="scope.row[col.key]"
                />
              </Col>
            </Row>
          </div>
          <div v-else-if="col.key === 'imageName' && unOfficalPlan(scope.row.sourceId)">
            <Poptip trigger="hover" transfer style="width: 100%">
              <span class="span-hidden">{{ scope.row[col.key] }}</span>
              <template #content>
                <img width="300px" height="200px" :src="scope.row.imageLittleImgUrl" />
              </template>
            </Poptip>
            <div>
              <el-button type="text" size="small" @click="$emit('on-image-bind', scope.row)">
                {{ scope.row[col.key] ? '[修改]' : '选择' }}
              </el-button>
              <Poptip
                confirm
                transfer
                title="确定要解绑已选素材吗？"
                @on-ok="$emit('on-image-cancel-bind', scope.row)"
                style="margin-right: 8px"
              >
                <el-button v-if="scope.row[col.key]" type="text" size="small">[取消]</el-button>
              </Poptip>
            </div>
          </div>
          <div v-else-if="col.key === 'pageId' && unOfficalPlan(scope.row.sourceId)">
            <Poptip trigger="hover" transfer>
              <span class="span-hidden">{{ scope.row[col.key] }}</span>
              <template #content>
                <img width="300px" height="200px" :src="scope.row.landPageLittleImgUrl" />
              </template>
            </Poptip>
            <div>
              <el-button type="text" size="small" @click="$emit('on-page-bind', scope.row)">
                {{ scope.row[col.key] ? '[修改]' : '选择' }}
              </el-button>
              <Poptip
                confirm
                transfer
                title="确定要解绑已选素材吗？"
                @on-ok="$emit('on-page-cancel-bind', scope.row)"
                style="margin-right: 8px"
              >
                <el-button v-if="scope.row[col.key]" type="text" size="small">[取消]</el-button>
              </Poptip>
            </div>
          </div>
          <span v-else-if="col.key === 'platform'">{{ scope.row[col.key] | convertPlatform }}</span>
          <span v-else-if="col.key === 'launchType'">{{ scope.row[col.key] | convertLaunchType }}</span>
          <span v-else-if="col.key === 'packageStatus'">{{ scope.row[col.key] | convertPackageStatus }}</span>
          <span v-else-if="col.key === 'proxyAccountName'">{{ scope.row[col.key] || '无' }}</span>
          <span v-else-if="col.key === 'planMediaExt'">
            <!--  platform 5 鸿蒙不显示 -->
            <template v-if="scope.row.mediaId === 214 && scope.row.platform !== 5">
              <span v-if="!scope.row[col.key]">
                <el-button @click="$emit('create-retry-huawei-extend-pkg', scope.row)" :loading="scope.row.retryLoading" type="text"
                  >新建
                </el-button>
                未创建
              </span>
              <span v-else-if="scope.row[col.key].success">成功</span>
              <span v-else
                ><el-button @click="$emit('create-retry-huawei-extend-pkg', scope.row)" :loading="scope.row.retryLoading" type="text"
                  >重试</el-button
                >创建失败，失败原因：{{ scope.row[col.key].msg }}
              </span>
            </template>
            <span v-else>————</span>
          </span>
          <span v-else-if="col.key.indexOf('Time') > -1">{{ scope.row[col.key] | datetimeToDay }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
const debugTestMediaArray = [16, 6, 10, 26, 87, 155, 32, 33, 145, 142, 165, 169, 172, 170, 8, 173, 59, 14, 104, 112, 109, 98, 60, 130]
const officialSourceId = [22791, 132431, 179973, 27650, 27715, 100]

export default {
  name: 'TrackPlanTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    height: {
      type: Number
    },

    columns: {
      type: Array
    }
  },
  computed: {
    hasOperateTrackPlan() {
      return this.access.includes('M20994')
    },
    hasDataEntryPlan() {
      return this.access.includes('M20995')
    },
    hasModifyPlanAccount() {
      return this.access.includes('M20996')
    },
    hasAgentPlan() {
      return this.access.includes('M21266')
    }
  },
  methods: {
    select(val) {
      this.$emit('on-select', val)
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    isNeedTestConnectMedia(mediaId, callType) {
      if (mediaId === 45 && callType != null && callType === 1) {
        return true
      }
      if (debugTestMediaArray.includes(Number(mediaId))) {
        return true
      }
      return false
    },
    unOfficalPlan(sourceId) {
      return !officialSourceId.includes(sourceId)
    }
  },
  data() {
    return {
      access: this.$store.state.accessAuth
    }
  },
  filters: {
    convertLaunchType(originVal) {
      switch (originVal) {
        case 1:
          return '直接下载'
        case 2:
          return '进入落地页'
      }
      return ''
    },
    convertPlatform(originVal) {
      switch (originVal) {
        case 1:
          return '安卓'
        case 2:
          return 'iOS'
        case 3:
          return '小程序'
        case 5:
          return '鸿蒙'
      }
    },
    convertPackageStatus(originVal) {
      const emuns = ['待打包', '正在打包', '打包完成', '打包失败', '正在批量打包']
      return emuns[originVal]
    },
    convertMediaPlanId(originVal) {
      if (!originVal) return '————'
      if (originVal.indexOf('advertiser_id') === 0) {
        return originVal.substr(13)
      } else if (originVal.indexOf('keywordId') === 0) {
        return originVal.substr(9)
      } else if (originVal.indexOf('scene_id') === 0) {
        return originVal.substr(8)
      }
      return originVal
    }
  }
}
</script>
<style lang="scss" scoped>
// 内容过长隐藏
// .el-overflow {
//   width: 100%;
//   display: inline-block;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }

// 点击样式
.click-style {
  cursor: pointer;
  visibility: hidden;
}

// span隐藏样式
.span-hidden {
  display: inline-block;
  width: 100%;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.h-row:hover {
  .click-style {
    visibility: visible;
  }
}

::v-deep .el-button--small {
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
